module.exports = __webpack_public_path__ + "img/billing.479d1e03.png";